<template>
    <div class="bg-nomad-900 rounded-xl p-6 min-w-0 text-nomad-100" v-if="song">
        <h1 class="text-lg font-semibold text-white">Playlist connection</h1>
        <div class="mt-4">
            <ul class="flex flex-col gap-4">
                <li class="flex items-center">
                    <div class="flex-auto min-w-0">
                        <h2 class="font-semibold text-white truncate">{{ song.name }}</h2>
                        <h3 class="text-sm">{{ song.artist.name }}</h3>
                        <div v-if="song.featuring"><span v-for="artist in song.featuring">{{ artist.name }}, </span></div>
                    </div>
                    <div>
                        <a :href="'/song/' + song.id" class="icon-external-link text-xl text-nomad-accent" target="_blank"></a>
                    </div>
                </li>
                <li class="flex flex-wrap gap-2" v-if="contents.length">
                    <button class="bg-nomad-800 text-white rounded-full px-3 py-1.5 text-sm hover:bg-nomad-700"
                        v-for="playlist in contents" @click.prevent="removeContent(playlist.id)">{{ playlist.name }} ({{
                            playlist.songs_count }}) <span class="icon-x"></span></button>
                </li>
                <li>
                    <input type="text" class="w-full rounded-lg bg-nomad-800 border border-nomad-700 text-white placeholder:text-nomad-400 focus:border-nomad-accent focus:ring-nomad-accent" placeholder="Search playlists" v-model="query" />
                    <div class="relative">
                        <ul class="absolute inset-x-0 top-full z-20 mt-2 max-h-72 overflow-y-auto rounded-lg bg-nomad-800 text-white shadow-xl" v-if="results">
                            <li v-for="playlist in results" v-bind:key="song.id"><button
                                    @click.prevent="selectContent(playlist)"
                                    class="flex w-full items-center gap-2 text-left p-2 hover:bg-nomad-700"><span
                                        class="icon-music text-nomad-accent"></span><span class="min-w-0 truncate">{{ playlist.name }}</span></button></li>
                        </ul>
                    </div>
                </li>

                <li>
                    <button @click.prevent="savePlaylistConnection"
                        class="shrink-0 rounded-lg bg-nomad-accent text-nomad-900 font-semibold px-4 h-11 hover:bg-nomad-accent/80">Attach
                        playlist</button>
                </li>

            </ul>

        </div>
    </div>
</template>
<script>
import { debounce, remove } from '@/utils/helpers';

export default {
    data() {
        return {
            song: null,
            query: null,
            contents: [],
            results: {}
        }
    },
    created() {
        this.getSong()
    },
    methods: {
        getSong() {
            axios.post('/api/backstage/no-playlist-song')
                .then((response) => {
                    this.song = response.data
                })
        },
        selectContent(content) {
            this.contents.push(content);
            this.results = {};
            this.query = null
        },
        getContent() {
            if (this.query) {
                axios
                    .get("/api/backstage/playlist-search?q=" + this.query)
                    .then((response) => {
                        this.results = response.data
                    });
            }
        },
        removeContent(id) {
            remove(this.contents, function (n) {
                return n.id === id
            })
        },
        savePlaylistConnection() {
            axios.post('/api/backstage/playlist-attach', { 'song': this.song.id, 'playlists': this.contents })
                .then((response) => {
                    this.contents = [],
                        this.results = {};
                    this.query = null
                    this.getSong()
                })
        },
    },
    watch: {
        query: debounce(function (newval, oldval) {
            this.getContent(newval);
        }, 1000),
    },
}
</script>